<script>
  import jQuery from 'jquery';

  import Header from '@components/Header.svelte';
  import MobileHeader from '@app-components/mobile/Header.svelte';
  import PreloadBox from '@components/PreloadBox.svelte';

  let mobile = jQuery(window).width() < 870;
</script>

<style style="text/scss" lang="scss">
  .preloader-group {
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 1000;
    padding-top: 10px;

    .grid-container.group-page-container-desktop {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .grid-content {
        width: 100%;
        max-width: 1180px;
        margin-left: auto;
        margin-right: auto;

        .group-header {
          margin-bottom: 36px;
          display: flex;
          align-items: flex-start;

          .group-details-container {
            flex: 1;

            .group-name-and-settings {
              display: flex;
              align-items: flex-start;
            }

            .group-sections {
              margin-top: 40px;
              display: flex;
            }
          }
        }
      }
    }
  }
</style>

<div class="preloader-group">
  {#if mobile}
    <MobileHeader />
  {:else}
    <Header currentUser={{ can_search_user: false }} currentPage="group" showCurrentUser={false} />

    <div style="padding: 45px 90px;" class="grid-container group-page-container-desktop">
      <div class="grid-content">
        <div class="group-header">
          <div class="group-details-container">
            <div class="group-name-and-settings">
              <PreloadBox style="height: 280px;" />
            </div>
            <div class="group-sections">
              <PreloadBox style="height: 300px; width: 380px; margin-right: 20px;" />
              <PreloadBox style="height: 300px; width: 380px;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>
